import { Button } from "@/components/ui/button";
import {
	DialogClose,
	DialogContent,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";

interface DeleteTabDialogProps {
	tabName: string;
	handleConfirm: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export const DeleteTabDialog = ({
	tabName,
	handleConfirm,
}: DeleteTabDialogProps) => {
	return (
		<DialogContent className="w-auto px-[40px]" aria-label="confirm delete tab">
			<DialogHeader>
				<DialogTitle>Are you sure you want to delete {tabName}?</DialogTitle>
			</DialogHeader>
			<DialogFooter className="flex items-center !justify-center gap-3">
				<Button
					variant="destructive"
					type="button"
					onClick={handleConfirm}
					className="bg-gold hover:bg-background text-background hover:text-gold w-[100px] hover:border border-gold"
				>
					Yes
				</Button>

				<DialogClose asChild>
					<Button variant="outline" className="w-[100px]">
						No
					</Button>
				</DialogClose>
			</DialogFooter>
		</DialogContent>
	);
};
